import { render, staticRenderFns } from "./ForgotPin.vue?vue&type=template&id=701350f6&"
import script from "./ForgotPin.vue?vue&type=script&lang=js&"
export * from "./ForgotPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports